import { gql } from 'graphql-request';

export const CREATE_POA_USER = gql`
  mutation CorePOAUsers($snils: String!, $userType: String!, $request: JSONObject!) {
    corePOAUsers {
      createRepresentative(input: { snils: $snils, userType: $userType, request: $request })
    }
  }
`;
